import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";
import FieldWrapper from "./FieldWrapper";
import GraduationStream from "./Fields/GraduationStream";
import GraduationUniversity from "./Fields/GraduationUniversity";
import GraduationPercentage from "./Fields/GraduationPercentage";
import Backlogs from "./Fields/Backlogs";
import WorkExperience from "./Fields/WorkExperience";
import {FormUl} from "./loaderStyled";

const CurrentEducationMasterSection: React.FC = () => {
    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);

    const masterFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.masterFields,
    );

    const PhDFields = useSelector((state: RootStore) => state.RegistrationLoginPage.phdFields);

    const gradutaionData = level ? (level === "Masters" ? masterFields : PhDFields) : undefined;

    return useMemo(() => {
        if (gradutaionData) {
            return (
                <FormUl>
                    {gradutaionData?.graduationUniversity && (
                        <FieldWrapper
                            visible={gradutaionData.graduationUniversity.visible}
                            addEmptyLi={true}
                            loading={gradutaionData.graduationStream.loading ?? false}
                        >
                            <GraduationUniversity
                                configuration={gradutaionData.graduationUniversity}
                            />
                        </FieldWrapper>
                    )}
                    {gradutaionData?.graduationStream && (
                        <FieldWrapper
                            visible={gradutaionData.graduationStream.visible}
                            loading={gradutaionData.graduationStream.loading ?? false}
                        >
                            <GraduationStream configuration={gradutaionData.graduationStream} />
                        </FieldWrapper>
                    )}
                    {gradutaionData?.graduationPercentage && (
                        <FieldWrapper
                            visible={gradutaionData.graduationPercentage.visible}
                            loading={gradutaionData.graduationPercentage.loading ?? false}
                            loaderType="Range Input"
                        >
                            <GraduationPercentage
                                configuration={gradutaionData.graduationPercentage}
                            />
                        </FieldWrapper>
                    )}
                    {gradutaionData?.backlogs && (
                        <FieldWrapper
                            visible={gradutaionData.backlogs.visible}
                            loading={gradutaionData.backlogs.loading ?? false}
                            loaderType="Range Input"
                        >
                            <Backlogs configuration={gradutaionData.backlogs} />
                        </FieldWrapper>
                    )}
                    {gradutaionData?.workExperience && (
                        <FieldWrapper
                            visible={gradutaionData.workExperience.visible}
                            loading={gradutaionData.workExperience.loading ?? false}
                            loaderType="Range Input"
                        >
                            <WorkExperience configuration={gradutaionData.workExperience} />
                        </FieldWrapper>
                    )}
                </FormUl>
            );
        }
        return null;
    }, [gradutaionData]);
};

export default CurrentEducationMasterSection;
